import { render, staticRenderFns } from "./ShowInfoCardPostingHistoryModal.vue?vue&type=template&id=585d899e&"
import script from "./ShowInfoCardPostingHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ShowInfoCardPostingHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports